const shortNameLength = 50;
const nameLength = 100;
const amountLength = 19;
const textLength = 255;
const longTextLength = 2000;
const newVersionPasswordLength = 25;
const oldVersionPasswordLength = 100;
const phoneNumberLength = 11;
const telLength = 25;
const emailLength = 100;

export const otpCodeLength = 6;

export const minPhoneNumberLength = 10;
export const minPasswordLength = 5;
export const minStrongPasswordLength = 8;

export const teamNameLength = nameLength;
export const teamLevelNameLength = nameLength;

export const forgetPasswordNewPassLength = newVersionPasswordLength;
export const changePasswordNewPassLength = newVersionPasswordLength;
export const changePasswordOldPassLength = oldVersionPasswordLength;
export const loginPasswordLength = oldVersionPasswordLength;
export const registerPhoneNumberLength = phoneNumberLength;
export const registerPasswordLength = newVersionPasswordLength;

export const backupFilePasswordLength = newVersionPasswordLength;

export const loginPhoneNumberLength = phoneNumberLength;
export const recoveryPhoneNumberLength = phoneNumberLength;

export const budgetAmountLength = amountLength;

export const reasonForRejectPettyCashLength = longTextLength;

export const transactionAmountLength = amountLength;
export const transactionDescription = textLength;
export const invoiceNumberLength = 15;
export const transactionSubItemAmountLength = amountLength;
export const transactionSubItemDescriptionLength = textLength;
export const transactionSubItemVatAmountLength = amountLength;

export const ticketTitleLength = nameLength;
export const ticketTextLength = longTextLength;

export const checkPhoneNumberPhoneLength = phoneNumberLength;

export const accountingCodeLength = 10;

export const pettyCashNumberNumLength = 5;

export const projectNameLength = nameLength;

export const vatPercentLength = 5;

export const userNameLength = shortNameLength;
export const userFamilyLength = shortNameLength;
export const userEmailLength = emailLength;

export const inviteUserPhoneLength = phoneNumberLength;

export const subItemNameLength = nameLength;
export const subItemDescriptionLength = textLength;

export const contactTelLength = telLength;

export const pettyCashPrintDescriptionLength = textLength;

export const promoCodeLength = 20;